import type { SymbolKey } from '@/entities/symbol/types';

export function isEmptySymbol(symbol: SymbolKey | null | undefined) {
  return symbol === null || symbol === undefined || symbol.Code === '';
}
